import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ProductListing from "../Components/ProductListing";
import NoImageFound from "../Util/NoImageFound";
import BottomAccordion from "../Util/BottomAccordion";
import { postRequests } from "../../../api/_common";
import { Filters } from "../../../views/IDX/ProductDetails";
import { useDispatch, useSelector } from "react-redux";
import { CListGroup } from "@coreui/react";
import { propertyListing } from "../../../api/idx";
import { changeSorting, onToggleFilter } from "../../../state/filterActions";
interface NewProductDetailsProps {
  count: number;
  propertylisting: any;
  handleSorting: (type: string) => void;
  loading: boolean;
  currentPage: number;
  pagescountstartend: { start: number; end: number };
  prevPage: () => void;
  nextPage: () => void;
  cityDetailsData: any;
  oddata: any;
  handleOnSearch: any;
  setAddress: any;
  filter: any;
  setFilter: any;
  selectedSort: any;
  setSelectedSort: any;
  handlePropertyTypeChange: any;
  loadingForProType: any;
}

export const NewProductDetails: React.FC<NewProductDetailsProps> = (props) => {
  const {
    count,
    propertylisting,
    handleSorting,
    loading,
    currentPage,
    prevPage,
    nextPage,
    pagescountstartend,
    oddata,
    cityDetailsData,
    setAddress,
    handleOnSearch,
    filter,
    setFilter,
    selectedSort,
    setSelectedSort,
    handlePropertyTypeChange,
    loadingForProType,
  } = props;

  const dispatch = useDispatch();
  const [sorting, setSorting] = useState({
    new_listing: null,
    lowest_price: null,
    highest_price: null,
    year_built: null,
    open_house_date: null,
    recently_reduced: null,
    largest_sqft: null,
    lot_size: null,
  });

  let proper = () => {
    return localStorage.getItem("filtervalue");
  };

  const handleFilterChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedValue = event.target.value;
    localStorage.setItem("selectedValue", selectedValue);
    setSelectedSort(selectedValue);
    let res = await proper();
    let parsedProper = JSON.parse(res);
    Object.keys(sorting).forEach((key) => {
      parsedProper[key] = key === selectedValue ? true : null;
    });

    try {
      dispatch({
        type: "SET",
        payload: parsedProper,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const isSortType = useSelector(
    (store: any) => store?.filterReducer?.isSortType
  );
  const pageNo = useSelector((store: any) => store?.filterReducer?.pageNo);

  return (
    <>
      {/* {count !== 0 ? ( */}
      <section
        className={
          propertylisting?.length == undefined || propertylisting?.length == 0
            ? "productdetails withError"
            : "productdetails"
        }
      >
        <div className="container-fluid custom-container">
          {!loadingForProType ? (
            <>
              {/* {propertylisting?.length > 0 && !loading ? ( */}
              {!loading ? (
                <div className="d-flex justify-content-between">
                  <h4 className="product-title">{oddata} results</h4>
                  <div className="sorting">
                    <select
                      name=""
                      id=""
                      className="form-select mr-2"
                      onChange={(e) => {
                        dispatch(
                          changeSorting({
                            sortKey: e.target.value,
                            sortValue: true,
                          })
                        );
                        dispatch(onToggleFilter());
                      }}
                      value={isSortType}
                    >
                      <option value="" hidden>
                        Sort
                      </option>
                      <option value="new_listing">Newest listings</option>
                      <option value="lowest_price">Lowest price</option>
                      <option value="highest_price">Highest price</option>
                      <option value="year_built">Year built</option>
                      <option value="open_house_date">Open house date</option>
                      <option value="recently_reduced">Recently reduced</option>
                      <option value="largest_sqft">Largest sqft</option>
                      <option value="lot_size">Lot size</option>
                      {/* <option value="">None</option> */}
                    </select>
                    <span className="mr-2">Sort</span>
                    <div onClick={() => handleSorting("ascending")}>
                      <span>
                        <i className="fa-solid fa-arrow-down"></i>
                      </span>
                    </div>
                    <div onClick={() => handleSorting("descending")}>
                      <span>
                        <i className="fa-solid fa-arrow-up"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          <>
            {loadingForProType ? (
              <>
                <div className="productlist mt-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between">
                        <h4 className="product-title">
                          <span className="d-flex ">
                            <Skeleton width={100} />
                            <Skeleton width={100} className="ml-2" />
                          </span>
                        </h4>
                        <div className="sorting">
                          <Skeleton width={160} />
                          <span>
                            <Skeleton />
                          </span>
                          <div>
                            <span>
                              <Skeleton />
                            </span>
                          </div>
                          <div>
                            <span>
                              <Skeleton />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div className="col-lg-3 col-md-6" key={index}>
                        <Skeleton count={4} height={190} />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="productlist mt-3">
                  <div className="row">
                    {loading ? (
                      <>
                        <div className="col-md-12">
                          <div className="d-flex justify-content-between">
                            <h4 className="product-title">
                              <span className="d-flex ">
                                <Skeleton width={100} />
                                <Skeleton width={100} className="ml-2" />
                              </span>
                            </h4>
                            <div className="sorting">
                              <Skeleton width={160} />
                              <span>
                                <Skeleton />
                              </span>
                              <div>
                                <span>
                                  <Skeleton />
                                </span>
                              </div>
                              <div>
                                <span>
                                  <Skeleton />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {Array.from({ length: 4 }).map((_, index) => (
                          <div className="col-lg-3 col-md-6" key={index}>
                            <Skeleton count={4} height={190} />
                          </div>
                        ))}
                      </>
                    ) : propertylisting?.length > 0 ? (
                      propertylisting?.map((v: any) => {
                        return (
                          <div className="col-lg-3 col-md-6">
                            <ProductListing
                              propertylisting={v}
                              currentPage={currentPage}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <NoImageFound />
                    )}
                  </div>
                </div>
                {propertylisting?.length > 0 ? (
                  <div className="productpagination">
                    <button
                      onClick={prevPage}
                      disabled={pageNo === 1}
                      className="productlistPrev"
                    >
                      Previous
                    </button>
                    <span>
                      Showing {pagescountstartend.start} -{" "}
                      {pagescountstartend.end >= oddata
                        ? oddata
                        : pagescountstartend.end}{" "}
                      of {oddata} {/* of {count} */}
                    </span>
                    <button
                      onClick={nextPage}
                      disabled={pagescountstartend.end >= oddata}
                      className="productlistNext"
                    >
                      Next
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        </div>
      </section>
      {/* ) : ( */}
      {/* <NoImageFound /> */}
      {/* )} */}
      {/* @ts-ignore */}
      <BottomAccordion // @ts-ignore
        cityDetailsData={cityDetailsData}
        handleOnSearch={handleOnSearch}
        setAddress={setAddress}
        filter={filter}
        setFilter={setFilter}
        handlePropertyTypeChange={handlePropertyTypeChange}
      />
    </>
  );
};
